import React from 'react';

const SvgComponent = (props) => (
  <svg viewBox="0 0 18 18" width="1em" height="1em" {...props}>
    <path d="M0 2.5v13h18v-13H0zm1.249 1.249H8.4v1.467c-1.193.215-1.96 1.01-1.96 2.121 0 1.494 1.342 1.91 2.059 2.133l.637.203.004.002c.957.297 1.219.51 1.219.988 0 .914-1.089.985-1.423.985-1.283 0-1.292-.651-1.295-.866L6.44 10.8c.016 1.108.753 1.847 1.959 2.012v1.439h-7.15V3.749zm15.502 10.502H9.6v-1.467c1.193-.215 1.959-1.01 1.959-2.121 0-1.494-1.342-1.91-2.063-2.135l-.637-.203c-.957-.297-1.219-.51-1.219-.988 0-.914 1.089-.985 1.423-.985 1.283 0 1.292.651 1.295.866l1.2-.018c-.014-1.108-.751-1.846-1.958-2.012V3.749h7.151v10.502z" />
  </svg>
);

export default SvgComponent;
